<template>
	<div id="pow-app">
		<TheHeader/>
		<div class="panels">
			<TheInfo/>
			<TheForm/>
		</div>
		<background-cards/>
		<the-footer/>
	</div>
</template>

<script>
import TheHeader from './components/TheHeader';
import BackgroundCards from './components/BackgroundCards';
import TheInfo from './components/TheInfo';
import TheForm from './components/TheForm/TheForm';
import TheFooter from './components/TheFooter';

export default {
	name: 'pow-app',
	components: { TheHeader, BackgroundCards, TheInfo, TheForm, TheFooter },
};
</script>

<style lang=less>
	@import url('../node_modules/normalize.css/normalize.css');
	@import (reference) 'assets/less/default.less';

	@font-face {
		font-family: 'futura-pt';
		src: url('assets/fonts/hinted-subset-FuturaBT-Medium.eot');
		src: local('Futura Medium BT'), local('FuturaBT-Medium'),
			url('assets/fonts/hinted-subset-FuturaBT-Medium.eot?#iefix') format('embedded-opentype'),
			url('assets/fonts/hinted-subset-FuturaBT-Medium.woff') format('woff'),
			url('assets/fonts/hinted-subset-FuturaBT-Medium.ttf') format('truetype');
		font-weight: 500;
		font-style: normal;
	}

	@font-face {
		font-family: 'futura-pt-bold';
		src: url('assets/fonts/hinted-subset-FuturaBT-Bold.eot');
		src: local('Futura Bold BT'), local('FuturaBT-Bold'),
			url('assets/fonts/hinted-subset-FuturaBT-Bold.eot?#iefix') format('embedded-opentype'),
			url('assets/fonts/hinted-subset-FuturaBT-Bold.woff') format('woff'),
			url('assets/fonts/hinted-subset-FuturaBT-Bold.ttf') format('truetype');
		font-weight: bold;
		font-style: normal;
	}

	html { font-size: 15px; box-sizing: border-box; }
	html, body { position: relative; overflow-x: hidden; }
	*, *:before, *:after { box-sizing: inherit; }

	input, textarea { outline: none; border-radius: 0;
		@media @mobile, @tablet { font-size: 16px; }
	}

	body { .regular(); .font-antialiasing(); }
	.panels { position: relative; display: flex; flex-direction: row;
		&:before { .top-left(0, 50%); content: ""; display: inline-block; width: 0; height: 0; margin-left: -34.5px; border-style: solid; border-width: 30px 34.5px 0 34.5px; border-color: white transparent transparent transparent; }
	}

	h1, h2, h3, h4 { .bold(); }

	@media @mobile, @tablet {
		.panels { flex-direction: column;
			&:before { display: none; }
		}
	}
</style>



// WEBPACK FOOTER //
// src/App.vue